import { render, staticRenderFns } from "./tBoxUpgrade.vue?vue&type=template&id=453e9a39&scoped=true&"
import script from "./tBoxUpgrade.vue?vue&type=script&lang=js&"
export * from "./tBoxUpgrade.vue?vue&type=script&lang=js&"
import style0 from "./tBoxUpgrade.vue?vue&type=style&index=0&id=453e9a39&prod&scoped=true&lang=less&"
import style1 from "./tBoxUpgrade.vue?vue&type=style&index=1&id=453e9a39&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "453e9a39",
  null
  
)

export default component.exports